module.exports = __webpack_public_path__ + "img/titleicon.041acfea.png";